export const EN_LANG = 'en';
export const FR_LANG = 'fr';
